import * as React from 'react';
import { Button } from "../..";

var InlineFieldAction = function InlineFieldAction(_ref) {
  var onClick = _ref.onClick,
      icon = _ref.icon,
      disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement(Button, {
    type: "button",
    appearance: "icon",
    icon: icon,
    size: "small",
    disabled: disabled,
    onClick: onClick
  });
};

export { InlineFieldAction };
export default InlineFieldAction;